import { render, staticRenderFns } from "./ApplyCarDetail.vue?vue&type=template&id=952c9504&scoped=true"
import script from "./ApplyCarDetail.vue?vue&type=script&lang=js"
export * from "./ApplyCarDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplyCarDetail.vue?vue&type=style&index=0&id=952c9504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952c9504",
  null
  
)

export default component.exports